<template>
  <section>
    <div class="z-card border-0 integration-page">
      <h4>{{ $t('integration.api.what_api') }}</h4>
      <p v-html="$t('integration.api.zorra_api_text')"></p>

      <h4>{{ $t('integration.api.authorization') }}</h4>
      <p v-html="$t('integration.api.api_requests')"></p>
      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/auth/login</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> POST</li>
        <li><b>Params:</b> email, password</li>
      </ul>
      <p>{{ $t('integration.api.example') }}</p>
      <pre>
<code class="json hljs">
{
    <span class="hljs-attr">"email"</span>: <span class="hljs-string">"example@domain.com"</span>,
    <span class="hljs-attr">"password"</span>: <span class="hljs-string">"your password"</span>
}

</code>
      </pre>
      <p>
        {{ $t('integration.api.request_header') }}
      </p>
      <p>
        {{ $t('integration.api.answer_example') }}
      </p>
      <pre>
<code class="json hljs">
{
    <span class="hljs-attr">"access_token"</span>: <span class="hljs-string">"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9uZXcuem9ycmEuY29tXC9hcGlcL2F1dGhcL2xvZ2luIiwiaWF0IjoxNTI1MzUxMzcxLCJleHAiOjE1MjUzODczNzEsIm5iZiI6MTUyNTM1MTM3MSwianRpIjoiakV2OXRJbWhnUDVPbDhxayIsInN1YiI6MywicHJ2IjoiODdlMGFmMWVmOWZkMTU4MTJmZGVjOTcxNTNhMTRlMGIwNDc1NDZhYSJ9.1A9gcnqQs7GbczuGc6XT78QiSlAoYxusFrO78beIuU4"</span>,
    <span class="hljs-attr">"token_type"</span>: <span class="hljs-string">"bearer"</span>,
    <span class="hljs-attr">"expires_in"</span>: <span class="hljs-number">36000</span>
}

</code>
      </pre>
    </div>
  </section>
</template>

<script>
  export default {};
</script>
<style lang="scss">
  @import '~@/assets/styles/scss/highlight/monokai';
  @import '~@/assets/styles/scss/pages/integration';
</style>
